module.exports = __webpack_public_path__ + "static/eikenvloer-2-05346eae8504dcba6428b61f685ae793.jpg";